<template lang="">
    <div class="mt-5">
       <h2>Tableau Links</h2>
           <v-snackbar
            :value="value"
            absolute
            right
            :timeout="timeout"
            color="success"
            top
          >
            data berhasil di update
          </v-snackbar>
        <!-- modal add tableau link -->
        <v-card class="px-5 py-5 mt-5">
            <v-dialog
              v-model="dialog"
              persistent
              max-width="600px"
              >
                <template v-slot:activator="{ on, attrs }">
                <v-btn
                    color="#5E50A1"
                    dark
                    v-bind="attrs"
                    v-on="on"
                >
                    Create New
                </v-btn>
                </template>
                <v-card>
                  <v-card-title>
                      <span class="text-h5">Tableau Link</span>
                  </v-card-title>

                  <form @submit.prevent="createTableauLink()">
                    <v-card-text>
                      <v-label>Purpose</v-label>
                      <v-text-field  
                          outlined
                          dense
                          v-model="purpose"
                          name="purpose"
                          type="text"
                      ></v-text-field>

                      <v-label>Admin Hub Code</v-label>
                      <v-text-field
                          outlined
                          dense
                          v-model="adminHub"
                          type="text"
                      ></v-text-field>

                      <v-label>Role</v-label>
                      <v-text-field
                          outlined
                          dense
                          v-model="role"
                          type="text"
                      ></v-text-field>

                      <v-label>Link</v-label>
                      <v-textarea
                          outlined
                          dense
                          v-model="link"
                          type="text"
                      ></v-textarea>
                    
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                        color="warning"
                        @click="dialog = false"
                        >
                        Close
                        </v-btn>
                        <v-btn   type="submit" color="#5E50A1" style="color:#fff;" >SUBMIT</v-btn>

                    </v-card-actions>
                  </form>
                </v-card>
              </v-dialog>
        </v-card>

        <!-- modal add tableau link -->
        
        <!-- modal edit tableau link -->
         <v-dialog v-model="dialog2" width="600">
           <v-card>
                <v-card-title>
                    <span class="text-h5">Form Edit Tableau Link</span>
                </v-card-title>
                 <form @submit.prevent="updateTableauLink()">
                    <v-card-text>
                                <v-label>Admin Hub Code</v-label>
                                <v-text-field
                                    outlined
                                    dense
                                    v-model="adminHub2"
                                    type="text"
                                ></v-text-field>
                                <v-label>Purpose</v-label>
                                <v-text-field  
                                    outlined
                                    dense
                                    v-model="purpose2"
                                    name="purpose"
                                    type="text"
                                ></v-text-field>
                                <v-label>Role</v-label>
                                <v-text-field
                                    outlined
                                    dense
                                    v-model="role2"
                                    type="text"
                                ></v-text-field>
                                <v-label>Link</v-label>
                                <v-textarea
                                  outlined
                                  outlined
                                  dense
                                  v-model="link2"
                                ></v-textarea>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                color="warning"
                                @click="dialog2 = false"
                                >
                                Close
                                </v-btn>
                                <v-btn   type="submit" color="#5E50A1" style="color:#fff;" >SAVE</v-btn>

                            </v-card-actions>
                        </form>
                </v-card>
         </v-dialog>
        
    <!-- modal edit tableau link -->
    <v-skeleton-loader class="mt-5" v-if="firstLoad" :loading="loading" type="table"></v-skeleton-loader>
    <v-col
         md="4"
    >
      <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
        

    </v-col>
    <v-col
          class="d-flex"
          cols="12"
          sm="2"
        >
          <v-select
            :items="showData"
            label="show"
            outlined
            :value="defaultShow"
            @input="handleFilterShowData"
          ></v-select>
        </v-col>
  
   <p>Total Data :{{totalData}}</p>
    <v-data-table
      dense
      :headers="headers"
      ref="ownershipContent"
      :items="data"
      v-show="!firstLoad"
      :fixed-header="true"
      item-key="no"
      :search="search"
      :page.sync="page"
      :items-per-page="itemsPerPage"
      hide-default-footer=""
      @page-count="pageCount = $event"
      class="mt-5 elevation-5"
      style="padding: 15px"
      :options.sync="options"
    >
      <template v-slot:item="row">
        <tr>
          <td>{{row.index+1}}</td>
          <td>{{ row.item.admin_hub_code }}</td>
          <td>{{ row.item.purpose }}</td>
          <td>{{ row.item.role }}</td>
          <td>{{ row.item.link.slice(0,10)+"&hellip;" }}</td>
          <td>{{ row.item.uploaded_by }}</td>
          <td style="display:flex">
            <div style="padding: 2px">
            
              <v-btn @click="delUpload(row.item.id)" v-model="mirrorId" color="red" small
                ><v-icon small color="white">
                  mdi-delete
                </v-icon></v-btn
              >
            </div>
            <div style="padding: 2px">
              <v-btn color="warning" small @click="editTableauLink(row.item.id)"
                ><v-icon small color="white">
                  mdi-pen
                </v-icon></v-btn
              >
            </div>
          </td>
        </tr>
      </template>
    </v-data-table>

    <div style="display: flex; justify-content: end; margin-top: 20px">
      <p class="mt-2" v-show="!firstLoad"> page {{ page }} to {{ RecordsTotal }}</p>
      <v-pagination
       v-show="!firstLoad"
        v-model="page"
        :length="RecordsTotal"
        :total-visible="5"
        color="#5E50A1"
        :options.sync="options"
        @input="handlePageChange"
      >
      </v-pagination>
    </div>

    </div>
</template>
<script>

export default {
  data() {
    return {
      dialog: false,
      dialog2: false,
      loading: false,
      purpose: "",
      adminHub: "",
      role: "",
      link: "",
      timeout: 3000,
      firstLoad: true,
      filename: null,
      firstLoad: true,
      page: 1,
      defaultShow:100,
      showData:[15,25,50,100],
      options: {},
      value: false,
      idSegment: [],
      timeout: 3000,
      disable: false,
      mirrorId: [],
      pageCount: 0,
      RecordsTotal:null,
      RecordsFiltered:null,
      itemsPerPage: null,
      totalData:null,
      numDefault:1,
      numNext:null,
      items: null,
      purpose2: "",
      Id2: "",
      uploaded2: "",
      adminHub2: "",
      role2: "",
      search:"",
      link2: "",
      loading: false,
      headers: [
        { id: 2, text: "No", value: "admin_hub_code" },
        { id: 2, text: "Admin Hub Code", value: "admin_hub_code" },
        { id: 3, text: "Purpose", value: "purpose" },
        { id: 4, text: "Role", value: "role" },
        { id: 5, text: "Link", value: "link" },
        { id: 6, text: "Uploaded By", value: "uploaded_by" },
        { id: 7, text: "Action", value: "butn" },
      ],
      data: [],
    };
  },
  methods: {
    // filterOnlyCapsText (value, query, item) {
    //   console.log(value)
    //   return value != null &&
    //     query != null &&
    //     typeof value === 'string' &&
    //     value.toString().toLocaleUpperCase().indexOf(query) !== -1
    //     //console.log(value)
    // },
    getTableauLinks(x) {
      const length = x.limit
      this.$store
        .dispatch("getAllTableauLinks",x)
        .then((response) => {
          if (response.data.code == 200) {
            const item = response.data.data;
            let z = item.RecordsTotal / length
            const showPage = item.RecordsFiltered
            this.RecordsFiltered = showPage
            console.log(this.RecordsFiltered)
            this.itemsPerPage = length
            console.log(item.RecordsFiltered)
            this.RecordsTotal = Math.ceil(z)
            this.firstLoad = false;
            this.data = item.records  
            this.totalData = item.RecordsTotal
            
          }
        })
        .catch(function (error) {});
    },
    createTableauLink() {
      this.loading = true;
      const items = {
        items: [
          {
            purpose: this.purpose,
            admin_hub_code: this.adminHub,
            role: this.role,
            link: this.link,
          },
        ],
      };
      this.$store
        .dispatch("postCreateTableauLink", items)
        .then((response) => {
          if (response.status == 201 || response.status == 200) {
            console.log("teeesa", response);

            setTimeout(() => (this.loading = false), 2000);
            this.$router.go(this.$router.currentRoute);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    delUpload(id) {
      console.log(id);
      this.$swal({
        title: "Hapus Data? ",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
      }).then((result) => {
        if (result.value) {
          this.$store.dispatch("deleteTableauLink", id).then((response) => {
            console.log(response);
            this.$swal("Berhasil dihapus").then((result) => {
              console.log(result);
              if (result.value) {
                this.$router.go(this.$router.currentRoute);
              }
            });
          });
        }
      });
    },
    editTableauLink(id) {
      console.log("edit", id);
      this.$store.dispatch("editTableauLink", id).then((response) => {
        if (response.status == 201 || response.status == 200) {
          const tableauLink = response.data.data.records;
          tableauLink.forEach((x) => {
            this.Id2 = x["id"];
            this.purpose2 = x["purpose"];
            this.adminHub2 = x["admin_hub_code"];
            this.role2 = x["role"];
            this.link2 = x["link"];
            this.uploaded2 = x["link"];
          });
          this.dialog2 = true;
        }
      });
    },
    updateTableauLink() {
      const item = {
        id: this.Id2,
        purpose: this.purpose2,
        admin_hub_code: this.adminHub2,
        role: this.role2,
        link: this.link2,
        uploaded_by: this.uploaded2,
      };
      console.log(item["id"]);

      this.$store.dispatch("updateTableauLink", item).then((response) => {
        if (response.status == 201 || response.status == 200) {
          this.dialog2 = false;
          this.value = true;
          this.$router.go(this.$router.currentRoute);
        }
      });
    },
    handlePageChange(value) {
      let payload={limit:this.defaultShow,page:value}
      this.page = payload.page
      this.getTableauLinks(payload)
    },
    handleFilterShowData(x){
      console.log(this.page)
      let payload={limit:x,page:1}
      this.defaultShow = x
      this.page=1
      this.getTableauLinks(payload)
    }
  },
  mounted() {
    this.getTableauLinks({limit:this.defaultShow,page:1});
   
  },
};
</script>
<style scoped>
.v-input.v-input--is-label-active.v-input--is-dirty.theme--light.v-text-field.v-text-field--is-booted.v-select {
  width: 70px;
}
</style>